/**
 * @Author: brand
 * @Date: 2019-06-28 15:42
 * @Email: brandhuang@qq.com
 */

import ax from '../../axios'

// 首页数据统计
export function IndexOverviewAPI(params) {
    return ax({
        url: '/wlapi/index/totalData',
        method: 'POST',
        params
    })
}
// 今日客服活动
export function IndexServiceActiveAPI(params) {
    return ax({
        url: '/wlapi/index/indexCsInfo',
        method: 'GET',
        params
    })
}
// 评价详情
export function IndexCsInfoAPI(params) {
    return ax({
        url: '/wlapi/index/csInfo',
        method: 'POST',
        params
    })
}
//获取今日该公司下所有的访客时段
export function IndexStatisticalAPI(params) {
    return ax({
        url: '/wlapi/index/time_interval_visitor_statistical',
        method: 'POST',
        params
    })
}
//获取省市分布
export function IndexNationalAPI(params) {
    return ax({
        url: '/wlapi/index/national_distribution',
        method: 'POST',
        params
    })
}

// 首页顶部相关工单数据
export function getTotalTicketsCountAPI (params) {
    return ax({
        url: '/wlapi/tickets/totalTicketsCount',
        method: 'POST',
        params
    })
}

//近七日工单详情
export function getSevenDayTicketsCountAPI (params) {
    return ax({
        url: '/wlapi/tickets/sevenDayTicketsCount',
        method: 'POST',
        params
    })
}

// 工单中心
export function getTicketsCenterAPI (params) {
    return ax({
        url: '/wlapi/tickets/ticketsCenter',
        method: 'POST',
        params
    })
}